import { cn } from '@/lib/utils';

export interface IconProps {
  /** Material Symbols Outlined ligature name (design/DESIGN.md lists the allowed ones). */
  name: string;
  size?: number;
  fill?: boolean;
  className?: string;
  /** Accessible name; without it the icon is decorative. */
  label?: string;
}

/** Material Symbols icon (the design's icon set); lucide is used only inside shadcn internals. */
export function Icon({ name, size = 20, fill = false, className, label }: IconProps) {
  const opsz = Math.min(48, Math.max(20, size));
  return (
    <span
      className={cn('icon-symbol', className)}
      style={{ fontSize: size, fontVariationSettings: `"FILL" ${fill ? 1 : 0}, "wght" 400, "GRAD" 0, "opsz" ${opsz}` }}
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
    >
      {name}
    </span>
  );
}
